/**
 * 2+2 gift (3 Nov 2026): buy 4 pairs, get 2 Hardcase XL and a ten-pack of
 * microfibre cloths free. A/B test: half of visitors (cookie hl_ab = B, set in
 * layout/theme.liquid) get the gift; the other half (A) get nothing and are
 * the control. Every cart that has items carries the cart attribute ab_gift
 * (A or B) so orders can be split afterwards.
 *
 * The gift lines are two $0 products ("Free gift" variants, handles
 * gift-hardcase-xl and gift-microfibre-cloths). The cart is reconciled after
 * every cart change: arm B with 4 or more frames gets exactly 2 cases and 1
 * cloth pack; any other cart gets none. Kill switch: set enabled to false in
 * layout/theme.liquid (HL_GIFT.enabled).
 */
(function () {
  var C = window.HL_GIFT;
  if (!C || !C.enabled || !C.caseVariant || !C.clothVariant) return;
  var arm = document.documentElement.getAttribute('data-hl-ab') || 'A';
  var rawFetch = window.fetch.bind(window);
  var busy = false, again = false, own = false;

  function getCart() {
    return rawFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function framesIn(c) {
    var n = 0;
    c.items.forEach(function (i) { if (C.frames.indexOf(i.handle) !== -1) n += i.quantity; });
    return n;
  }
  function qtyOf(c, id) {
    var q = 0;
    c.items.forEach(function (i) { if (i.variant_id === id) q += i.quantity; });
    return q;
  }

  // Re-render the parts of the page that carry a cart number, the same way
  // the add-ons block does, so totals and the bag count follow the change.
  function refresh() {
    var jobs = [];
    var cd = document.querySelector('cart-drawer-component');
    if (cd) {
      jobs.push(rawFetch('/?section_id=cart-drawer-section').then(function (r) { return r.text(); }).then(function (h) {
        var f = new DOMParser().parseFromString(h, 'text/html').querySelector('cart-drawer-component');
        if (f) cd.innerHTML = f.innerHTML;
      }).catch(function () {}));
    }
    if (/\/cart\/?$/.test(location.pathname)) {
      jobs.push(rawFetch('/cart').then(function (r) { return r.text(); }).then(function (h) {
        var d = new DOMParser().parseFromString(h, 'text/html');
        ['.cart-totals', '.cart-items', 'cart-items-component'].forEach(function (s) {
          var a = document.querySelector(s), b = d.querySelector(s);
          if (a && b) a.innerHTML = b.innerHTML;
        });
      }).catch(function () {}));
    }
    jobs.push(getCart().then(function (c) {
      document.querySelectorAll('cart-icon').forEach(function (i) {
        if (typeof i.renderCartBubble === 'function') i.renderCartBubble(c.item_count);
      });
    }).catch(function () {}));
    return Promise.all(jobs);
  }

  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    getCart().then(function (c) {
      var want = arm === 'B' && framesIn(c) >= C.minFrames;
      var wc = want ? C.caseQty : 0, wm = want ? C.clothQty : 0;
      var updates = {}, change = false;
      if (qtyOf(c, C.caseVariant) !== wc) { updates[C.caseVariant] = wc; change = true; }
      if (qtyOf(c, C.clothVariant) !== wm) { updates[C.clothVariant] = wm; change = true; }
      var attrs = c.attributes || {};
      var needAttr = c.item_count > 0 && attrs.ab_gift !== arm;
      if (!change && !needAttr) return;
      var body = {};
      if (change) body.updates = updates;
      if (needAttr) body.attributes = { ab_gift: arm };
      own = true;
      return rawFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function () { return change ? refresh() : null; })
        .then(function () { own = false; }, function () { own = false; });
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; setTimeout(reconcile, 60); }
    });
  }

  // Watch every cart call the theme and the add-ons block make, whatever event
  // name Horizon uses, and reconcile once it has finished.
  window.fetch = function (u) {
    var p = rawFetch.apply(window, arguments);
    try {
      var url = typeof u === 'string' ? u : ((u && u.url) || '');
      if (!own && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        p.then(function () { setTimeout(reconcile, 150); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  document.addEventListener('DOMContentLoaded', reconcile);
  window.addEventListener('pageshow', reconcile);
  document.addEventListener('shopify:cart:lines-update', function () { if (!own) setTimeout(reconcile, 150); });
})();
